import { isArray, isObject } from '@/global/utils/utils'
import { isNumber, isString } from 'lodash/lang'
import { dateService } from '@/global/services/date'

export function makeFormData (data, fileKeys = [], additionalValues = {}, datesTransform = {}) {
  if (!data && !isObject(data)) return

  const formData = new FormData()
  Object.keys(data).forEach(key => {
    const value = data[key]

    if (isArray(value)) {
      value.forEach(arrayVal => {
        if (isNumber(arrayVal) || isString(arrayVal)) {
          formData.append(`${key}[]`, arrayVal)
        }
      })
    }
    else if (value && isObject(value)) {
      formData.append(key, value.id || '')
    }
    else if (value !== undefined && value !== null) {
      formData.append(key, value)
    }
  })

  if (fileKeys.length) {
    fileKeys.forEach(fileKey => {
      const value = data[fileKey]
      const files = value?.map(file => file?.file || null) || []
      files.forEach(file => {
        if (file) {
          formData.append(`${fileKey}[]`, file)
        }
      })
    })
  }

  if (additionalValues && isObject(additionalValues)) {
    Object.keys(additionalValues).forEach(key => {
      const value = additionalValues[key]
      formData.append(key, value)
    })
  }

  if (datesTransform && isObject(datesTransform)) {
    Object.keys(datesTransform).forEach(key => {
      const { fromFormat, toFormat } = datesTransform[key] || {}
      const value = data[key] || {}

      if (fromFormat && toFormat && value) {
        const transformedDate = dateService.formatCustom(value, fromFormat, toFormat)
        formData.append(key, transformedDate)
      }
    })
  }

  return formData
}
